export default "__VITE_ASSET__BYbczqW2__"